import { createReducer } from 'redux-act';

import {
  CLASS_CATEGORY_FETCH_DATA_INIT,
  CLASS_CATEGORY_FETCH_DATA_SUCCESS,
  CLASS_CATEGORY_FETCH_DATA_FAIL,
  CLASS_CATEGORY_DELETE_INIT,
  CLASS_CATEGORY_DELETE_SUCCESS,
  CLASS_CATEGORY_DELETE_FAIL,
  CLASS_CATEGORY_CLEAR_DATA,
  CLASS_CATEGORY_CREATE_INIT,
  CLASS_CATEGORY_CREATE_SUCCESS,
  CLASS_CATEGORY_CREATE_FAIL,
  CLASS_CATEGORY_MODIFY_INIT,
  CLASS_CATEGORY_MODIFY_SUCCESS,
  CLASS_CATEGORY_MODIFY_FAIL,
  CLASS_CATEGORY_CLEAN_UP,
  CLASS_CATEGORY_CLEAR_DATA_LOGOUT
} from '../../actions/classCategories';

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false,
  deleted: false
};

export const classCategoriesReducer = createReducer(
  {
    [CLASS_CATEGORY_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true
    }),
    [CLASS_CATEGORY_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload.categories,
      loading: false,
      error: null
    }),
    [CLASS_CATEGORY_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [CLASS_CATEGORY_DELETE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [CLASS_CATEGORY_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.filter(elem => elem.id !== payload.id),
      loading: false,
      error: null,
      deleted: true
    }),
    [CLASS_CATEGORY_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [CLASS_CATEGORY_CLEAR_DATA]: state => ({
      ...initialState,
      data: state.data
    }),
    [CLASS_CATEGORY_CREATE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [CLASS_CATEGORY_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.concat(payload),
      loading: false,
      error: null,
      success: true
    }),
    [CLASS_CATEGORY_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [CLASS_CATEGORY_MODIFY_INIT]: state => ({
      ...state,
      loading: true
    }),
    [CLASS_CATEGORY_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.map(elem => {
        if (elem.id === payload.id) {
          return payload;
        }
        return elem;
      }),
      loading: false,
      error: null,
      success: true
    }),
    [CLASS_CATEGORY_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [CLASS_CATEGORY_CLEAN_UP]: state => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false
    }),
    [CLASS_CATEGORY_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState
    })
  },
  initialState
);
